import React from 'react'
import { Form, Field, reduxForm } from 'redux-form'
import RenderFormField from 'components/render-form-field'
import { passwordValidator } from 'util/field-validation'
import striptags from 'striptags'
import SubmitButton from 'components/buttons/submit-button'

const ResetPasswordForm = ({ submitting, loading, error, handleSubmit }) => {
  const submitDisabled = submitting || loading

  const formError = error ? (
    <div
      className='form--error'
      data-ext='form--error-reset-password'
      dangerouslySetInnerHTML={{ __html: striptags(error, ['a']) }}
    />
  ) : null

  return (
    <Form
      id='ext--reset-password-form'
      data-test-key='reset-password-form'
      className='form'
      method='POST'
      noValidate='novalidate'
      onSubmit={handleSubmit}
    >
      <Field
        name='password'
        placeholder='Password'
        component={RenderFormField}
        type='password'
        autoFocus
        validate={passwordValidator}
      />

      {formError}

      <div className='form-group'>
        <SubmitButton
          text='Reset'
          loading={submitDisabled}
          disabled={submitDisabled}
          testKey='reset-password-submit'
        />
      </div>
    </Form>
  )
}

export default reduxForm({
  form: 'resetPassword',
  destroyOnUnmount: true,
  touchOnChange: true,
})(ResetPasswordForm)
